export default "__VITE_ASSET__BxspXBRa__"